// extracted by mini-css-extract-plugin
export default {"container":"mwMUZuDMsTbFS2IzUHjt","titleContainer":"JRkc4j4s2ocoUbE9ufMo","line":"q_OtQQ_Y2Yu6nXgxg436","title":"IKo_I0w1rjfapAgsA9W7","bodyContainer":"job0Nsixeq7y3jIPjeu8"};